import Vue from 'vue'
import Router from 'vue-router'
import { publicRoute, protectedRoute } from './config'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const routes = publicRoute.concat(protectedRoute)
const loginPath = '/auth/login'

Vue.use(Router)
const router = new Router({
  linkActiveClass: 'active',
  routes: routes,
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})
// router gards
// eslint-disable-next-line
router.beforeEach((to, from, next) => {
  NProgress.start()

  if (to.path !== loginPath && !localStorage.getItem('isLoggedIn')) {
    next({ path: '/auth/login' })
  } else {
    document.title = `TSB Living - ${to.name}`
    next()
  }
})

// eslint-disable-next-line
router.afterEach((to, from) => {
  NProgress.done()
})

export default router
